import { API_ROOT } from '../../config/config'
import { doGet, doPost, doDownload, doPostFiles, doPostDownload } from './utils'

const API_ROOT_VER = `${API_ROOT}/v1/accounting`
const API_ROOT_VERs = `${API_ROOT}/files`
const API_ROOT_VER2 = 'http://localhost:9009/api/files'
const API_ROOT_VER3 = 'http://localhost:9014/api/v1/accounting'

export const getListDepreciationAssets = (projectCode, pageNumber, pageSize) => {
  const url = `${API_ROOT_VER}/asset-depreciation-lists/${projectCode}?pageNumber=${pageNumber}&pageSize=${pageSize}`
  return doGet(url)
}

export const searchListDepreciationAssets = (projectCode, request, pageNumber, pageSize) => {
  const url = `${API_ROOT_VER}/asset-depreciation-lists/${projectCode}/search/?pageNumber=${
    pageNumber || 0
  }&pageSize=${pageSize || 0}`
  return doPost(url, request)
}

export const downloadAssetDepreciationReport = (request) => {
  const url = `${API_ROOT_VERs}/download/accounting-asset-depreciation`
  return doPostDownload(url, request)
}
